export type SessionExpiredLoginState = Record<string, unknown>;

export type SessionExpiredData = {
  allowPath?: string;
  loginState?: SessionExpiredLoginState;
};

export const SESSION_EXPIRED_DATA_KEY = 'sessionExpiredData';

export const readSessionExpiredData = (): SessionExpiredData => {
  const raw = window.sessionStorage.getItem(SESSION_EXPIRED_DATA_KEY);
  if (!raw) return {};
  try {
    return JSON.parse(raw) as SessionExpiredData;
  } catch {
    console.error('Failed to parse sessionExpiredData');
    return {};
  }
};

export const writeSessionExpiredData = (data: SessionExpiredData): void => {
  try {
    window.sessionStorage.setItem(SESSION_EXPIRED_DATA_KEY, JSON.stringify(data));
  } catch {
    console.error('Failed to write sessionExpiredData');
  }
};

export const clearSessionExpiredData = (): void => {
  window.sessionStorage.removeItem(SESSION_EXPIRED_DATA_KEY);
};

export const readSessionExpiredAllowPath = (): string | null => {
  return readSessionExpiredData().allowPath ?? null;
};
